export const BRAND = {
  name: "Called It",
  tagline: "Receipts for the future.",
  hero_title: "What's your call?",
  hero_sub: "Think you know what's going to happen? Put it on the record.",
};

export const CATEGORY_LABELS = {
  technology: "Technology", ai: "AI", business: "Business", markets: "Markets",
  sport: "Sport", politics: "Politics", entertainment: "Entertainment", music: "Music",
  movies_tv: "Movies & TV", science: "Science", gaming: "Gaming", culture: "Culture",
  other: "Other",
};

export const CATEGORIES = Object.entries(CATEGORY_LABELS).map(([id, label]) => ({ id, label }));

export const REACTIONS = [
  { type: "bold", emoji: "🔥", label: "Bold" },
  { type: "watching", emoji: "👀", label: "Watching" },
  { type: "agree", emoji: "🤝", label: "Agree" },
  { type: "doubt", emoji: "🤨", label: "Doubt" },
];

export const STATUS_META = {
  pending: { label: "Pending", bg: "bg-locked", text: "text-ink", icon: "🔒" },
  called_it: { label: "Called It", bg: "bg-called", text: "text-ink", icon: "🏆" },
  missed_it: { label: "Missed It", bg: "bg-missed", text: "text-white", icon: "" },
  partial: { label: "Partially Correct", bg: "bg-locked", text: "text-ink", icon: "◐" },
  ambiguous: { label: "Ambiguous", bg: "bg-secondary", text: "text-ink", icon: "?" },
  cancelled: { label: "Cancelled", bg: "bg-secondary", text: "text-ink", icon: "✕" },
};
